import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import produce from 'immer';
import { collectionSliceName, collectionSliceInitialState } from '../common/constants';
import { getDataState } from './universalDataFetchers';
import logger from '../common/logger';

export const fetchCollectionData = createAsyncThunk(
  'collectionData',
  ({
    match, env, useMocks, lmsHeaders, isPreview,
  }, { rejectWithValue }) => {
    const { params } = match;
    return getDataState({
      params, env, useMocks, lmsHeaders, isPreview,
    }).catch((err) => rejectWithValue(err));
  },
);

export const collectionSlice = createSlice({
  name: collectionSliceName,
  initialState: collectionSliceInitialState,
  reducers: {},

  extraReducers: {

    [fetchCollectionData.pending]: (state) => ({
      ...state,
      data: {},
      isLoaderVisible: true,
    }),
    [fetchCollectionData.fulfilled]: (state, action) => {
      const data = action?.payload || {};
      if (!data.error) {
        const newState = produce(state, (draftState) => {
          draftState.data = data;
          draftState.isLoaderVisible = false;
        });

        return newState;
      }

      return state;
    },
    [fetchCollectionData.rejected]: (state, action) => {
      logger.error('Error in fetchCollectionData: ', action.payload);
      return {
        ...state,

      };
    },
  },
});

export const getCollectionData = (state) => state.collectionData.data;
export const isLoaderVisible = (state) => state.collectionData.isLoaderVisible;

export default collectionSlice.reducer;
